import { MenuRoute } from '../../shared/menu/menu-route.model';

/**
 * Menu-eligible routes exposed by the Reports module.
 * Only top-level static routes are listed (overview/timesheet sub-routes are reachable from these landings).
 */
export const REPORTS_MENU_ROUTES: MenuRoute[] = [
  {
    path: '/reports/dashboard',
    labelKey: 'Reports.dashboard',
    icon: '/assets/tablerIcons/outline/layout-dashboard.svg',
    moduleId: 17,
    groupLabelKey: 'MenuRoutes.group.reportsOverview'
  },
  {
    path: '/reports/overview',
    labelKey: 'Reports.overview',
    icon: '/assets/tablerIcons/outline/eye.svg',
    moduleId: 17,
    groupLabelKey: 'MenuRoutes.group.reportsOverview'
  },
  {
    path: '/reports/timesheet',
    labelKey: 'Reports.timesheet',
    icon: '/assets/tablerIcons/outline/calendar.svg',
    moduleId: 17,
    groupLabelKey: 'MenuRoutes.group.reportsTime'
  },
  {
    path: '/reports/time-report',
    labelKey: 'Reports.timeReport',
    icon: '/assets/tablerIcons/outline/clock.svg',
    moduleId: 17,
    groupLabelKey: 'MenuRoutes.group.reportsTime'
  },
  {
    path: '/reports/time-kpi-report',
    labelKey: 'Reports.timeKpiReport',
    icon: '/assets/tablerIcons/outline/chart-bar.svg',
    moduleId: 17,
    groupLabelKey: 'MenuRoutes.group.reportsTime'
  },
  {
    path: '/reports/absence-report',
    labelKey: 'Reports.absenceReport',
    icon: '/assets/tablerIcons/outline/user-off.svg',
    moduleId: 17,
    groupLabelKey: 'MenuRoutes.group.reportsAbsence'
  }
];
